import axiosInstance from "@/libs/axios_config";
import { setBypassMaintenance, setMaintenanceInfo, setMaintenanceMode } from "@/storage/maintenance/maintenanceSlice";
import { RootState } from "@/storage/store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export const MaintenanceWrapper = () => {
    const dispatch = useDispatch()
    const { isOnMaintenance, bypassMaintenance } = useSelector(
        (state: RootState) => state.Maintenance
    );
    const [loading, setLoading] = useState(true)
    let didInit = false

    const checkMaintenanceStatus = async () => {
        try {
            const response = await axiosInstance.get("/maintenance")
            const data = await response.data
            const maintenance_mode = data.maintenance_mode
            if (!maintenance_mode)
                dispatch(setBypassMaintenance(false))
            dispatch(setMaintenanceMode(maintenance_mode || false))
            dispatch(
                setMaintenanceInfo({
                    title: data.title,
                    message: data.message,
                })
            )
        } catch (error) {
            if (isOnMaintenance) {
                dispatch(setBypassMaintenance(false))
                dispatch(setMaintenanceMode(false))
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (! didInit) {
            didInit = true
            checkMaintenanceStatus()
        }
    }, [dispatch])

    if (loading) return <></>

    if (isOnMaintenance && !bypassMaintenance && location.pathname !== "/maintenance") {
        return <Navigate to="/maintenance" />
    }

    return <Outlet />
};
